module.exports = __webpack_public_path__ + "img/img_aviodPhoney_04.063d61f2.jpg";